import React from 'react';
import PropTypes from 'prop-types';
import loader from './loader.svg';

const LargePreLoader = props => (
  <div className={props.classes}>
    <div>
      <div className="loader">
        <div className="loader-icon spinning-cog">
          <img alt="Загрузка" src={loader} />
        </div>
      </div>
    </div>
  </div>
);

LargePreLoader.defaultProps = {
  classes: ''
};

LargePreLoader.propTypes = {
  classes: PropTypes.string
};

export default LargePreLoader;



// WEBPACK FOOTER //
// ./src/components/Common/PreLoaders/LargePreLoader.js